'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463 from "./presto.types$-Directive-Path$$anon$63.js";
import * as $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464 from "./presto.types$-Directive-Path$$anon$64.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectivePath$() {
  this.c5K = null;
  this.c5L = false;
  this.c5I = null;
  this.c5J = false;
  this.c5O = null;
  this.c5P = false;
  this.c5M = null;
  this.c5N = false;
  this.c5Q = null;
  this.c5R = false;
}
export { $c_Lpresto_types$DirectivePath$ as $c_Lpresto_types$DirectivePath$ };
$p = $c_Lpresto_types$DirectivePath$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectivePath$;
/** @constructor */
function $h_Lpresto_types$DirectivePath$() {
}
export { $h_Lpresto_types$DirectivePath$ as $h_Lpresto_types$DirectivePath$ };
$h_Lpresto_types$DirectivePath$.prototype = $p;
$p.cI6 = (function() {
  if ((!this.c5L)) {
    this.c5K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c5L = true;
  }
  return this.c5K;
});
$p.v5 = (function() {
  if ((!this.c5J)) {
    this.c5I = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c5J = true;
  }
  return this.c5I;
});
$p.cIP = (function() {
  if ((!this.c5P)) {
    this.c5O = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c5P = true;
  }
  return this.c5O;
});
$p.csd = (function() {
  if ((!this.c5N)) {
    this.c5M = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002463.$c_Lpresto_types$DirectivePath$$anon$63(this);
    this.c5N = true;
  }
  return this.c5M;
});
$p.cJ5 = (function() {
  if ((!this.c5R)) {
    this.c5Q = new $j_presto$002etypes$0024$002dDirective$002dPath$0024$0024anon$002464.$c_Lpresto_types$DirectivePath$$anon$64(this);
    this.c5R = true;
  }
  return this.c5Q;
});
var $d_Lpresto_types$DirectivePath$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectivePath$, "presto.types$DirectivePath$", ({
  ZC: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectivePath$ as $d_Lpresto_types$DirectivePath$ };
var $n_Lpresto_types$DirectivePath$;
function $m_Lpresto_types$DirectivePath$() {
  if ((!$n_Lpresto_types$DirectivePath$)) {
    $n_Lpresto_types$DirectivePath$ = new $c_Lpresto_types$DirectivePath$();
  }
  return $n_Lpresto_types$DirectivePath$;
}
export { $m_Lpresto_types$DirectivePath$ as $m_Lpresto_types$DirectivePath$ };
//# sourceMappingURL=presto.types$-Directive-Path$.js.map
